import React from 'react';
import styled from 'styled-components';
import TopNavbar from '../../Nav/TopNavbar';
import Footer from '../Footer';
import WomanIntheCar from '../../../assets/img/WomanIntheCar.jpg';
import familyInCar from '../../../assets/img/familyInCar.jpg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function BlogsView() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const blogPosts = [
        {
            id: 1,
            image: WomanIntheCar,
            category: t('categoryProducts'),
            title: t('titleUseCITRIN'),
            description: t('descriptionUseCITRIN'),
            date: t('dateUseCITRIN'),
            link: 'blogs/how-to-use-citrin',
        },
        {
            id: 2,
            image: familyInCar,
            category: t('categoryProducts'),
            title: t('blog.titlePricingCITRIN'), // <- Add this too
            description: t('descriptionPricingCITRIN'), // <- Optional but consistent
            date: t('datePricingCITRIN'),
            link: 'blogs/citrin-dynamic-pricing',
        },
    ];

    const [featured, ...others] = blogPosts;

    return (
        <>
            <TopNavbar />
            <Wrapper>
                <Container>
                    {/* Featured Horizontal Blog */}
                    <FeaturedCard onClick={() => navigate('/' + featured.link)}>
                        <FeaturedImage src={featured.image} alt={featured.title} />
                        <FeaturedContent>
                            <Category>{featured.category}</Category>
                            <Title>{featured.title}</Title>
                            <Description>{featured.description}</Description>
                            <Meta>{featured.date}</Meta>
                        </FeaturedContent>
                    </FeaturedCard>

                    {/* Grid for Remaining Blogs */}
                    <Grid>
                        {others.map((blog) => (
                            <Card key={blog.id} onClick={() => navigate('/' + blog.link)}>
                                <Image src={blog.image} alt={blog.title} />
                                <CardContent>
                                    <Category>{blog.category}</Category>
                                    <Title>{blog.title}</Title>
                                    <Meta>{blog.date}</Meta>
                                </CardContent>
                            </Card>
                        ))}
                    </Grid>
                </Container>
            </Wrapper>
            <Footer />
        </>
    );
}

// Styled Components
const Wrapper = styled.section`
    width: 100%;
    background: #fff;
`;

const Container = styled.div`
    max-width: 1200px;
    padding: 60px 20px;
    margin: auto;
`;

const FeaturedCard = styled.a`
    display: flex;
    flex-direction: row;
    gap: 30px;
    margin-bottom: 60px;
    text-decoration: none;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    transition:
        transform 0.3s,
        box-shadow 0.3s;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 30px 30px 36px rgba(0, 0, 0, 0.15);
    }

    &:link,
    &:visited,
    &:active,
    &:hover {
        color: #000;
    }

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const FeaturedImage = styled.img`
    width: 50%;
    object-fit: cover;

    @media (max-width: 768px) {
        width: 100%;
        height: 200px;
    }
`;

const FeaturedContent = styled.div`
    padding: 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Category = styled.div`
    font-size: 0.75rem;
    color: #666;
    text-transform: uppercase;
    margin-bottom: 10px;
`;

const Title = styled.h2`
    font-size: 1.5rem;
    margin: 0 0 15px 0;
`;

const Description = styled.p`
    font-size: 1rem;
    color: #444;
    margin-bottom: 20px;
`;

const Meta = styled.div`
    font-size: 0.8rem;
    color: #999;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 30px;
`;

const Card = styled.a`
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    text-decoration: none;
    transition:
        transform 0.2s,
        box-shadow 0.2s;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 30px 30px 30px rgba(0, 0, 0, 0.15);
    }

    &:link,
    &:visited,
    &:active,
    &:hover {
        color: #000;
    }
`;

const Image = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;
`;

const CardContent = styled.div`
    padding: 20px;
`;
